import React from "react";
import { useFlowStore } from "../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../models/CanvasNode.ts";
import goalIcon from "../assets/node/goal.png";

interface GoalToggleProps {
    /** React Flow node id — the outer node, not data.id. */
    nodeId: string;
    isGoal?: boolean;
    goalName?: string;
}

/**
 * The name field for a step that has been marked a conversion goal.
 *
 * The mark/unmark control itself lives in the hover action strip next to delete and duplicate
 * (see NodeAction) — a permanent checkbox in every node cost a row of height on every step to
 * express something that is off on nearly all of them. This renders nothing until the flag is on,
 * so the node only grows for the steps that actually are goals, and its presence doubles as the
 * at-rest indicator for a strip that is only visible on hover.
 */
const GoalToggle: React.FC<GoalToggleProps> = ({ nodeId, isGoal, goalName }) => {
    const { nodes, setNodes } = useFlowStore();

    if (!isGoal) return null;

    const patch = (changes: Partial<CanvasNodeData>) => {
        setNodes(nodes.map((node: CanvasNode) =>
            node.id === nodeId
                ? { ...node, data: { ...(node.data as CanvasNodeData), ...changes } }
                : node
        ) as CanvasNode[]);
    };

    return (
        <div className="goal-toggle nodrag nopan">
            <div className="goal-label">
                <img src={goalIcon} width={10} alt="" />
                <span>Conversion goal</span>
            </div>
            <input
                className="goal-name"
                placeholder="Name this goal, e.g. Order placed"
                value={goalName ?? ""}
                onChange={(e) => patch({ goalName: e.target.value })}
            />
        </div>
    );
};

export default GoalToggle;
